import forge from "node-forge";
const PBU_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAi1C2z/t8uyLTZ6LshwoU
Ia5vVz7QhHuR1zs/UHrrQmNj2tEx0NADNRSu7sSy7+9DaLJ3ICW/CdHbbENjigan
GdAx32m9xTQu3mYDnDmBQrDaaec/PY+bTjp99gWaZweRbAXdjFYT+Ui/F2Jhnr3B
O0aPyjb1WldvzbglGsLwbRxvherBsfLhy5+BJUBhManE56i5+5XJ6DYQD/aagU5P
Fn+cdWYwWven6uWN6Tz2DpRMXz4dkk5NnENJvVGYreKflkGatFWcoETflQULBjy7
0DKObLOIEAxH4Aw0rKVq/Tm4aFY7GEiOlgVpnUFe4TC/RJnDMhIvLuqoGoag57MR
XwIDAQAB
-----END PUBLIC KEY-----`;
const encryptData = (data) => {
  const publicKey = forge.pki.publicKeyFromPem(PBU_KEY);
  const encryptedData = publicKey.encrypt(JSON.stringify(data), "RSA-OAEP", {
    md: forge.md.sha256.create(),
  });

  // Encode the encrypted data in base64
  const encryptedDataB64 = forge.util.encode64(encryptedData);
  return { data: encryptedDataB64 };
};

export default encryptData;
